import { render, staticRenderFns } from "./FormModV2.vue?vue&type=template&id=68daf362&scoped=true"
import script from "./FormModV2.vue?vue&type=script&lang=js"
export * from "./FormModV2.vue?vue&type=script&lang=js"
import style0 from "./FormModV2.vue?vue&type=style&index=0&id=68daf362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68daf362",
  null
  
)

export default component.exports